export const _shopFr = {
    optionActive: 'Option active',
    free: 'Gratuit',
    optionActives: 'Options actives',
    configPackBeginner: 'Pack de configuration débutant',
    configPackBeginnerDesc: `Ce pack de configuration débutant vous permettra de démarrer votre aventure sur ModuleRP.<br />
    Il contient :<br />
    - 3 bâtiments<br />
    - 11 types de véhicules<br />
    - 23 compétences de personnels<br />
    - 11 natures de sinistres`,
    buyConfigPackBeginner: 'Acheter le pack de configuration débutant',
    sig: 'Système d\'information géographique',
    sigDesc: `Activez le système d'information géographique pour permettre aux opérateurs de visualiser une carte.<br />
    Dans la mesure du possible et sans option supplémentaire, le système tentera de localiser sur la carte les bâtiments et les interventions.<br />
    Sous forme d'abonnement mensuel, le prix sera facturé en Extras tous les mois à la date de renouvellement.`,
    buySig: 'Acheter cette carte',
    worldMap: 'Carte du monde',
    gtaMap: 'Carte de GTA V',
    alpha: `Pendant la phase alpha, les achats ne sont pas facturés, vous pouvez donc tester les options sans perdre vos extras.
     Attention, les parties de la phase alpha ne seront pas conservées.`,
    selectOption: 'Sélectionner une option',
};

export const _shopEn = {
    optionActive: 'Option active',
    free: 'Free',
    optionActives: 'Active options',
    configPackBeginner: 'Beginner configuration pack',
    configPackBeginnerDesc: `This beginner configuration pack will allow you to start your adventure on ModuleRP.<br />
    It contains:<br />
    - 3 buildings<br />
    - 11 types of vehicles<br />
    - 23 personnel skills<br />
    - 11 types of disasters`,
    buyConfigPackBeginner: 'Buy the beginner configuration pack',
    sig: 'Geographic Information System',
    sigDesc: `Activate the geographic information system to allow operators to view a map.<br />
    As far as possible and without additional options, the system will try to locate on the map the buildings and interventions.<br />
    In the form of a monthly subscription, the price will be billed in Extras every month on the renewal date.`,
    buySig: 'Buy this map',
    worldMap: 'World map',
    gtaMap: 'GTA V map',
    alpha: `During the alpha phase, purchases are not billed, so you can test the options without losing your extras.
     Be careful, the games of the alpha phase will not be kept.`,
    selectOption: 'Select an option',
};

export const _shopDe = {
    optionActive: 'Option aktiv',
    free: 'Kostenlos',
    optionActives: 'Aktive Optionen',
    configPackBeginner: 'Anfängerkonfigurationspaket',
    configPackBeginnerDesc: `Dieses Anfängerkonfigurationspaket ermöglicht es Ihnen, Ihr Abenteuer auf ModuleRP zu starten.< br />
    Es enthält: <br />
    - 3 Gebäude<br />
    - 11 Fahrzeugtypen<br />
    - 23 Personalfähigkeiten < br />
    - 11 Arten von Katastrophen`,
    buyConfigPackBeginner: 'Kaufen Sie das Anfängerkonfigurationspaket',
    sig: 'Geografisches Informationssystem',
    sigDesc: `Aktivieren Sie das geografische Informationssystem, damit Betreiber eine Karte anzeigen können.<br />
    Soweit möglich und ohne zusätzliche Optionen wird das System versuchen, auf der Karte die Gebäude und Interventionen zu lokalisieren.<br />
    In Form eines monatlichen Abonnements wird der Preis jeden Monat zum Verlängerungsdatum in Extras berechnet.`,
    buySig: 'Kaufen Sie diese Karte',
    worldMap: 'Weltkarte',
    gtaMap: 'GTA V Karte',
    alpha: `Während der Alpha-Phase werden Käufe nicht in Rechnung gestellt, sodass Sie die Optionen testen können,
     ohne Ihre Extras zu verlieren. Achten Sie darauf, dass die Spiele der Alpha-Phase nicht aufbewahrt werden.`,
    selectOption: 'Wählen Sie eine Option',
};
